<template>
  <v-dialog v-model="dialog.show" persistent max-width="900">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-form ref="formCad">
            <v-row dense>
              <v-col cols="12" sm="12" md="8">
                <v-text-field label="Nome" :rules="[rules.required]" v-model="equipe.nome"></v-text-field>
              </v-col>

              <v-col cols="12" md="3" sm="12">
                <v-checkbox label="Ativa" v-model="equipe.ativo"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="salvar"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="reset()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Equipe from "@/services/equipe";
export default {
  name: "DialogEquipe",
  data() {
    return {
      tipo: "",
      dialog: {
        show: false,
        title: "Nova Equipe"
      },
      equipe: {
        codigoEquipe: "",
        nome: "",
        ativo: true
      },
      empresa: {
        cnpj: ""
      },

      rules: rules
    };
  },

  methods: {
    show(item) {
      this.equipe.nome = item.nome;
      this.equipe.ativo = item.ativo;
      this.empresa.cnpj = item.cnpj;
      this.equipe.codigoEquipe = item.codigoEquipe;
      this.dialog.title = "Editar Equipe";
      this.dialog.show = true;
    },
    async salvar() {
      if (this.$refs.formCad.validate()) {
        try {
          await new Equipe().updataNomeEquipe(
            this.equipe.codigoEquipe,
            this.empresa.cnpj,
            this.equipe
          );

          this.reset();
          this.$swal.success("Salvo com sucesso");
          this.$emit("OnSaved");
        } catch (error) {
          this.$alert.setAlert(true, "error", error);
        }
      }
    },
    reset() {
      this.equipe.nome = "";
      this.equipe.ativo = "";
      this.equipe.codigoEquipe = "";
      this.empresa.cnpj = "";
      this.dialog.show = false;
    }
  }
};
</script>

<style></style>
